import { RouterStateSnapshot } from '@angular/router';
import { TranslationId } from '../transloco';
import { SimpleRouterNavigationExtras } from './model/simple-router-navigation-extras';

export class CloseWindow {
  static readonly type = '[SimpleRouter] Close window';
}

export class RefreshWindow {
  static readonly type = '[SimpleRouter] Refresh window';
  constructor(public message?: TranslationId) {}
}

export class SetSimpleRouterState {
  static readonly type = '[SimpleRouter] Set simple router state';
  constructor(public snapshot: RouterStateSnapshot) {}
}

export class SetGuardsActivated {
  static readonly type = '[SimpleRouter] Set guards activated';
  constructor(public guardsActivated: boolean) {}
}

export abstract class NavigateAction {
  constructor(public path: string[], public extras?: SimpleRouterNavigationExtras | undefined) {}
}

export class Navigate extends NavigateAction {
  static readonly type = '[SimpleRouter] Navigate';
}

export class NavigateByUrl {
  static readonly type = '[SimpleRouter] Navigate by url';
  constructor(public url: string, public extras?: SimpleRouterNavigationExtras | undefined) {}
}

export abstract class GotoAction {
  constructor(public extras?: SimpleRouterNavigationExtras) {}
}
